import { createContext, useContext, useEffect, useState } from "react";

const FavoritesContext = createContext(null);
export const useFavorites = () => useContext(FavoritesContext);

export function FavoritesProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try {
      const parsed = JSON.parse(localStorage.getItem("vb_favorites"));
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("vb_favorites", JSON.stringify(ids));
  }, [ids]);

  const isFav = (id) => ids.includes(id);
  const toggle = (id) =>
    setIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

  return (
    <FavoritesContext.Provider value={{ ids, isFav, toggle, count: ids.length }}>
      {children}
    </FavoritesContext.Provider>
  );
}
